import React from "react";
import AAutoComplete from "./../../common/form-fields-mui/AAutoComplete";
import { Row, Col } from "reactstrap";
import { FormControlLabel } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";

import { ReactComponent as InfoIcon } from "assets/img/svg/infoIcon.svg";

import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import AToggleButtonGroup from "../../../../../components/AToggleButtonGroup/AToggleButtonGroup";

const FistLabel = ({
  form,
  handler,
  testTypesDropdown,
  isResultDatePassed,
  isDisableTestType,
  isTimeTableTest,
}) => {
  const { testType, isMandatory, testNameNew } = form;

  const startWithinChangeHandler = (status) => {
    handler(status === "Yes", "isStartWithin");
  };

  return (
    <>
      <Row className="mb-2">
        <Col md={4}>
          <AAutoComplete
            placeholder="Enter test type"
            currentValue={testType}
            handleChange={(value) => handler(value, "testType")}
            isMulti={false}
            isDisabled={isResultDatePassed || isDisableTestType}
            items={testTypesDropdown}
          ></AAutoComplete>
        </Col>
        <Col md={4}>
          <AInput
            value={testNameNew}
            placeholder="Enter test name"
            handler={(value) => handler(value, "testNameNew")}
            regex={new RegExp(/^[a-zA-Z0-9 ()-]*$/)}
            maxLength={50}
          ></AInput>
        </Col>
        <Col md={4}>
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={isMandatory}
                onChange={() => handler(!isMandatory, "isMandatory")}
                sx={{ "& .MuiSvgIcon-root": { fontSize: "20px" } }}
                disabled={isResultDatePassed || isDisableTestType}
              />
            }
            label="Mandatory test"
          />
        </Col>
      </Row>

      {!isTimeTableTest && (
        <div className="ml-2">
          <p className="mb-1 text-xs text-bold">
            Do you want to define start within time?
          </p>

          <Row className="ml-1 mb-4 d-flex align-items-center">
            <AToggleButtonGroup
              options={[
                { label: "No", value: "No" },
                { label: "Yes", value: "Yes" },
              ]}
              defaultSelected={form.isStartWithin ? "Yes" : "No"}
              allowDeselect={false}
              changeHandler={startWithinChangeHandler}
              // containerProps={{ disabled: !isObjEmpty(rowForm) }}
            />

            <div className="ml-3 d-flex align-items-center">
              <InfoIcon />
              <p className="ml-1 mb-0 text-xs">
                Only available for Online Tests
              </p>
            </div>
          </Row>
        </div>
      )}
    </>
  );
};

export default FistLabel;
